/**
 * Application Constants
 */

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

export const API_ENDPOINTS = {
  // Auth
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    REFRESH: '/api/auth/refresh',
    LOGOUT: '/api/auth/logout',
    ME: '/api/auth/me',
    GOOGLE: '/api/auth/google',
  },
  // Health
  HEALTH: '/api/health',
  // QR Codes
  QR: {
    CODES: '/api/qr-codes',
    TAGS: '/api/tags',
  },
  // Subscription
  SUBSCRIPTION: {
    PLANS: '/api/subscription/plans',
    CURRENT: '/api/subscription/current',
    CHECKOUT: '/api/subscription/checkout',
    PORTAL: '/api/subscription/portal',
    CANCEL: '/api/subscription/cancel',
    USAGE: '/api/subscription/usage',
  },
  // Admin
  ADMIN: {
    USERS: '/api/admin/users',
    STATS: '/api/admin/stats',
  },
  // API Keys
  API_KEYS: '/api/api-keys',
  // Feedback
  FEEDBACK: '/api/feedback',
  // Images (My Images)
  IMAGES: '/api/images',
  // Public API
  PUBLIC_API: {
    QR_CODES: '/api/v1/qr-codes',
  },
} as const;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PRICING: '/pricing',
  DASHBOARD: '/dashboard',
  QR_CODES: '/dashboard/qr-codes',
  BILLING: '/dashboard/billing',
  API_KEYS: '/dashboard/api-keys',
  IMAGES: '/dashboard/images',
  ADMIN_USERS: '/admin/users',
} as const;

export const QUERY_KEYS = {
  AUTH: {
    ME: ['auth', 'me'],
  },
  HEALTH: ['health'],
} as const;

